var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.memberData.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }